import { FC, ReactNode, PropsWithChildren } from "react";

interface Props {
  date: ReactNode;
  label?: string;
}

const RuleContainer: FC<PropsWithChildren<Props>> = ({
  date,
  children,
}): JSX.Element => {
  return (
    <div className="relative">
      <div className="EditableContent">{children}</div>

      <div className="block mt-[40px] text-xs">
        <p>tecture株式会社</p>
        <div>{date}</div>
      </div>
    </div>
  );
};

export default RuleContainer;
